import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import ScoreCompanyService from '../../../../../../../core/service'

export const getTrendOfScore = createAsyncThunk(
  'companyAnalysis/companyScore/creditRiskScore/getTrendOfScore',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScoreCompanyService.getTrendOfScore(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getDistributionScore = createAsyncThunk(
  'companyAnalysis/companyScore/creditRiskScore/getDistributionScore',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScoreCompanyService.getDistributionScore(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
